import React from 'react';

const EspecificacionesTecnicasSection = ({ product }) => (
    <div className="tab-pane active" role="tabpanel">
        <h3 className="text-lg font-semibold mb-3">Ficha Técnica</h3>
        <table className="table table-striped">
            <tbody>
                {product?.specifications?.map((spec, index) => (
                    <tr key={index}>
                        <th>{spec.key}</th>
                        <td>{spec.value}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default EspecificacionesTecnicasSection;
